import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormikControl from "../../formikcontrols";
import "./MasterModal.scss";
import {
  addDataFunc,
  languageOptionsUtility,
  showErrorNotification,
  showSuccessNotification,
  updateDataFunc,
} from "../../../customHooks";
const MasterModal = ({
  isOpen,
  closeModal,
  title,
  data,
  updateData,
  addData,
  url,
  setReload,
}) => {
  const [error, setError] = useState("");
  const [languageOption, setLanguageOption] = useState([]);
  var initialValues = {
    name: "",
    description: "",
    codeLanguagesId: "",
  };
  if (title == "Responsibility") {
    initialValues = { ...initialValues, codeLanguagesId: "" };
  }
  var validationSchema = Yup.object().shape({
    name: Yup.string().required(`${title} is required`).nullable(),
    //description: Yup.string().required("Descripton is Required").nullable(),
  });
  if (title === "Responsibility") {
    var validationSchema = Yup.object().shape({
      name: Yup.string().required(`${title} is required`).nullable(),
      codeLanguagesId: Yup.string()
        .min(1, "Language name is required")
        .required("Languages name are required")
        .nullable(),
    });
  }
  const getLanguageOptions = async () => {
    if (title === "Responsibility") {
      const exOptions = await languageOptionsUtility("name", "id");
      setLanguageOption(exOptions);
    }
  };

  const handleSubmit = async (values) => {
    if (data === undefined) {
      addDataFunc(url, values, setReload);
      closeModal();
    } else {
      if (data == values) {
        setError("Please change the value");
      } else {
        updateDataFunc(url, values, setReload);

        closeModal();
      }
    }
  };
  useEffect(() => {
    getLanguageOptions();
  }, []);

  return (
    <div>
      <Modal
        show={isOpen}
        onHide={isOpen}
        contentClassName="profilecontent"
        centered
      >
        <Modal.Header>
          <span className="modal__sec--head">
            <span className="highlight">
              {data === undefined ? "Add" : "Update"}
            </span>{" "}
            {title}
          </span>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={
              data === undefined
                ? initialValues
                : { ...data, codeLanguagesId: "data.codeLanguagesId" }
            }
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {(formik, values) => {
              return (
                <Form className="modal__sec--body-form">
                  {/* {console.log("formik.errors", formik.errors)} */}
                  <FormikControl
                    control="input"
                    label={title}
                    name="name"
                    required={true}
                    maxLength={45}
                  />
                  {title == "Responsibility" && (
                    <FormikControl
                      control="select"
                      label="Languages"
                      required={true}
                      name="codeLanguagesId"
                      options={languageOption && languageOption}
                      // values={values}
                      form={formik}
                      //isMulti={true}
                    />
                  )}
                  <FormikControl
                    control="textarea"
                    label="Description"
                    name="description"
                    placeholder="Allow only 100  character"
                    maxLength="100"
                  />
                  <div style={{ color: "red", fontSize: "10px" }}>{error}</div>
                  <Modal.Footer className="modal__sec--body-form-bottom">
                    <Button className="modal__sec--btn" type="submit">
                      {data === undefined ? "Add" : "Update"}
                    </Button>
                    <Button
                      className="modal__sec--btn modal__sec--btn-close"
                      onClick={closeModal}
                    >
                      Close
                    </Button>
                  </Modal.Footer>
                </Form>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MasterModal;
